import React from 'react'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { handleSemiConfigDownLoadOrderSummary } from '../../../utils/util'
import { DownloadOrderSummaryProps } from '../Enum'
import { semiConfigContext } from '../Shrna'

const useStyles = makeStyles((theme: Theme) => ({
  downloadWrapper: {
    textAlign: 'right',
    margin: theme.spacing(8, 0, -5),
  },
  print: {
    float: 'right',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
  },
  icon: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
}))

const DownloadSummary = () => {
  const classes = useStyles()
  const { state } = React.useContext(semiConfigContext)

  return (
    <div className={classes.downloadWrapper}>
      <CloudDownloadIcon fontSize="small" className={classes.icon} />
      <Typography className={classes.print}>
        <Link
          href="#"
          onClick={(e) =>
            handleSemiConfigDownLoadOrderSummary(
              e,
              DownloadOrderSummaryProps.ProductType,
              DownloadOrderSummaryProps.FileName,
              state.shrnaAddtoCartData
            )
          }
          className={classes.print}
          download
        >
          <FormattedMessage {...messages.CONF_DOWNLOAD_PRINT_SUMMARY} />
        </Link>
      </Typography>
    </div>
  )
}
export default DownloadSummary
